export default {
    drawer: null,
    color: 'primary',
    image: 'https://demos.creative-tim.com/vue-material-dashboard/img/sidebar-2.32103624.jpg',
    sidebarBackgroundColor: 'rgb(28, 28, 28)',
    loading: false
};
